<script>
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: null
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        hasFinishedLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        isDropdown: {
            type: Boolean,
            required: false,
            default: true
        }
    }
}
</script>

<template>
    <ul :class="{'dropdown-menu dropdown-menu-right scrollable-dropdown-menu': isDropdown}" :style="[isDropdown ? {'min-width': '360px'} : {}]">

        <li v-if="title" :class="{'dropdown-header': isDropdown}">
            {{ title }}
        </li>
        
        <slot />
        
        <div :class="{ 'm-b-10 m-l-10 m-r-10 m-t-10': isDropdown}" v-if="isLoading">
            <a href="" class="text-center btn btn-custom btn-block btn-trans btn-sm collapsed m-r-10 m-t-15 has-preloader disabled">
                <div class="preloader" style="height: 13px; margin: 0 !important; width: 13px;"></div>
            </a>
        </div>
        
        <div :class="{'m-b-10 m-l-10 m-r-10 m-t-10': isDropdown, 'm-t-5': !isDropdown}" v-if="hasFinishedLoading && !isLoading">
            <a href="#" @click.prevent.stop="$emit('load-more')" class="text-center btn btn-block btn-custom btn-trans btn-sm" >
                {{ trans('calendar.show_more') }}
                <i class="zmdi zmdi-chevron-down m-l-5"></i>
            </a>
        </div>
    </ul>
</template>

<style lang="scss" scoped>
ul {
    padding: 0;
}
</style>